import { useState } from 'react';
import { faqs } from '@/mocks/faqs';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };

  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-100/70">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-3">
            常见问题
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-900">
            关于永利皇宫的常见疑问
          </h2>
          <p className="text-foreground-600 text-sm mt-3">
            为您解答关于入住、餐饮、交通等方面的常见问题
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="rounded-xl bg-background-50 border border-secondary-200/60 overflow-hidden"
            >
              <button
                className="w-full flex items-center justify-between gap-4 px-5 md:px-6 py-4 text-left cursor-pointer hover:bg-background-100/70 transition-colors"
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
              >
                <h4 className="font-heading text-sm md:text-base font-medium text-foreground-900 pr-4">
                  {faq.question}
                </h4>
                <div className={`w-6 h-6 flex items-center justify-center shrink-0 rounded-full transition-all duration-300 ${
                  openIndex === index
                    ? 'bg-primary-500 text-background-50 rotate-45'
                    : 'bg-secondary-100 text-secondary-600'
                }`}>
                  <i className="ri-add-line text-sm"></i>
                </div>
              </button>
              <div
                className={`transition-all duration-300 overflow-hidden ${
                  openIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <div className="px-5 md:px-6 pb-5 text-foreground-600 text-sm leading-relaxed">
                  {faq.answer}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}